import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { api } from './client';
import { pollEvery } from '../realtime/live';

export type LaundryStatus = 'RECEIVED' | 'WASHING' | 'READY' | 'DELIVERED' | 'CANCELLED';

export interface LaundryItem {
  id: string;
  name: string;
  price: number;
  active: boolean;
}
export interface LaundryOrder {
  id: string;
  reference: string;
  customerName: string;
  phone: string | null;
  note: string | null;
  bookingId: string | null;
  status: LaundryStatus;
  pieces: number;
  total: number;
  createdAt: string;
  readyAt: string | null;
  deliveredAt: string | null;
  cancelReason: string | null;
  paid: boolean;
  paidWith: string | null;
  refunded: boolean;
  lines: { id: string; itemName: string; unitPrice: number; qty: number; total: number }[];
}

export const useLaundryPrices = (all = false) => useQuery({ queryKey: ['laundry', 'prices', all], queryFn: () => api<{ items: LaundryItem[] }>(`/laundry/prices${all ? '?all=1' : ''}`).then((r) => r.items) });
export const useLaundryOrders = (show: 'open' | 'done') => useQuery({ queryKey: ['laundry', 'orders', show], refetchInterval: pollEvery(30_000), queryFn: () => api<{ orders: LaundryOrder[] }>(`/laundry/orders?show=${show}`).then((r) => r.orders) });

export function useLaundryMutation<V, R = unknown>(run: (v: V) => Promise<R>) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: run,
    onSuccess: async () => {
      await Promise.all(['laundry', 'daily', 'bookings', 'rs'].map((k) => qc.invalidateQueries({ queryKey: [k] })));
    },
  });
}
